import { useEmbedContext } from '@osmosis/nextjs-components/context/EmbedProvider';
import { HEADER_LOGGED_IN_HEIGHT } from '../../styles/header';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { ZIndex } from '@osmosis/tailwind-ui/helpers/zIndex';
import { bg0, borderNeutral300 } from '@osmosis/tailwind-ui/styles';
import dynamic from 'next/dynamic';

const HeaderLoggedIn = dynamic(() => import('./HeaderLoggedIn'), {
  ssr: false,
});
const HeaderLoggedOut = dynamic(() => import('./HeaderLoggedOut'), {
  ssr: false,
});

/**
 * Renders the header component.
 * @param {boolean} headerSearchVisible - Indicates whether the header search is visible.
 */
export default function Header({
  headerSearchVisible,
  isLoggedIn,
}: {
  headerSearchVisible: boolean;
  isLoggedIn?: boolean;
}) {
  const { headerRef } = useEmbedContext();

  return (
    <Flex
      className={`space-between align-center ${bg0} w-full h-[${HEADER_LOGGED_IN_HEIGHT}px] fixed top-0 border-b ${borderNeutral300} `}
      style={{
        zIndex: ZIndex.HEADER,
      }}
      ref={headerRef}
    >
      {isLoggedIn ? (
        <HeaderLoggedIn headerSearchVisible={headerSearchVisible} />
      ) : (
        <HeaderLoggedOut headerSearchVisible={headerSearchVisible} />
      )}
    </Flex>
  );
}
